import type { ReactNode } from "react";

// #design-pass W9: Marken-Karte für die Auth-Seiten (Login + Setup). Body-Gradient
// scheint durch (kein eigener bg), zentrierte Karte mit Mesh-Logo + Titel + Sub.
function MeshMark() {
  return (
    <div className="grid h-11 w-11 place-items-center rounded-[12px] bg-gradient-to-br from-accent to-[#7c93f5] shadow-[0_4px_14px_rgba(58,85,217,.4)]">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="5" r="2" /><circle cx="5" cy="18" r="2" /><circle cx="19" cy="18" r="2" />
        <path d="M12 7v4M10.5 13 6.5 16M13.5 13l4 3" />
      </svg>
    </div>
  );
}

export function AuthCard({ title, description, children }: { title: string; description: ReactNode; children: ReactNode }) {
  return (
    <div className="grid min-h-screen place-items-center px-4">
      <div className="w-full max-w-[400px]">
        <div className="mb-6 flex flex-col items-center text-center">
          <MeshMark />
          <h1 className="mt-3.5 text-[20px] font-extrabold tracking-tight text-text">{title}</h1>
          <p className="mt-1 text-[13.5px] text-text2">{description}</p>
        </div>
        <div className="rounded-lg border border-border bg-surface p-7 shadow-lg">{children}</div>
      </div>
    </div>
  );
}
